import { signupService } from '@http/signupService'
import { trackingService } from '@http/trackingService'
import { User } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { getTrackingSuccess } from '@views/tracking/state/trackingSlice2'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { signup, signupAction, signupFailed, signupSuccess } from './signupSlice'

export function* signupHttp(action: signupAction) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const createdUser: User = yield call(signupService, action.payload, userId, cocap)
    const personalUsers: User[] = yield call(trackingService, userId, cocap, 'personal')
    yield put(getTrackingSuccess({ data: personalUsers, setSuccess: true }))
    yield put(signupSuccess(createdUser))
  } catch (e) {
    yield put(signupFailed(e.message))
  }
}

export default function* signupSaga() {
  yield takeEvery(signup.type, signupHttp)
}
